<p-dialog #dialog appendTo="body" position="top" [visible]="!!currentComponent"
          styleClass="past-values-dialog"
          [resizable]="!isMobileSize"
          [modal]="true"
          [draggable]="false"
          [closable]="false"
          [closeOnEscape]="true"
          (onHide)="close()">
    <ng-template pTemplate="header">
        <div class="p-grid p-nogutter">
            <div class="p-col-6">
                <label class="p-d-flex p-flex-column p-m-0" *ngIf="currentInstance">
                    <ng-container *ngTemplateOutlet="noteInfo; context: { note: currentInstance.noteToDetail ? currentInstance.noteToDetail : currentInstance.note, segmentName: currentInstance.templateSegment.longName, details: currentInstance.noteToDetail!!}">
                    </ng-container>
                </label>
            </div>
            <div class="p-col-6 p-text-right">
                <div class="p-d-inline-flex p-jc-md-end p-flex-md-row p-flex-column">
                    <button pButton class="p-button-secondary p-order-md-1 w-100" icon="pi pi-times" label="Close" (click)="close()"></button>
                    <span *ngIf="canGoBack" class="p-mt-1 p-mt-md-0 p-mr-md-1 p-order-md-0">
                        <button *ngIf="!history.length" pButton class="w-100" label="Back" icon="pi pi-chevron-left" (click)="goBack()"></button>
                        <p-splitButton *ngIf="history.length" label="Back" icon="pi pi-chevron-left" (onClick)="goBack()" [model]="history"></p-splitButton>
                    </span>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-container #container></ng-container>
</p-dialog>


<ng-template #noteInfo let-note="note" let-segmentName="segmentName" let-details="details">
    <span>{{note.noteTime | date: 'MM/dd/yyyy HH:mm'}}</span>
    <span>{{note.templateName}}{{note.keyIndicator ? (' - ' + note.keyIndicator) : ''}}</span>
    <span>{{details ? 'Note Details' : 'Past Values of ' +  '&quot;' + segmentName + '&quot;'}}</span>
</ng-template>